import { useEffect, useState } from "react";
import Paginator, { DataTypeEnum } from "../../../../../models/Paginator";
import Alert from "@material-ui/lab/Alert";

import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";

import { FormattedMessage, useIntl } from "react-intl";
import ICIPAdminService from "../../../../../services/ICIPAdminService";
import {
  Box,
  makeStyles,
  TableRow,
  TextField,
  Typography,
} from "@material-ui/core";
import RaffleDrawParticipant from "../../../../../models/RaffleDrawParticipant";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TableData, {
  StyledTableCell,
  StyledTableRow,
} from "../../../components/TableData";
import moment from "moment";
import { InputSelect } from "../../../../../components/input-select/InputSelect";
import MenuItem from "@material-ui/core/MenuItem";
import { FormikHelpers, useFormik } from "formik";
import * as Yup from "yup";

const useStyles = makeStyles((theme) => ({
  generalGrid: {
    marginBottom: 10,
  },
  tabHeading: {
    fontWeight: "bold",
    fontSize: 14,
  },
  newButton: {
    //textTransform: "none",
    fontSize: 13,
  },
  subButton: {
    textTransform: "none",
    fontSize: 10,
    width: 100,
  },
  exportButton: {
    width: 175,
    marginLeft: 50,
    alignContent: "left",
  },
  contentListParticipant: {
    padding: 50,
  },
  searchField: {
    padding: 50,
  },
}));

interface RaffleDrawParticipantsProps {}

export interface ParticipantTabData {
  original: Paginator;
  filtered: Paginator;
}

export const RaffleDrawParticipants = (props: RaffleDrawParticipantsProps) => {
  const classes = useStyles(props);
  const intl = useIntl();

  const [raffleDrawsParticipants, setRaffleDrawsParticipants] = useState({});
  const [participants, setParticipants] = useState([]);
  const [error, setError] = useState(false);
  const [raffleDraws, setRaffleDraws] = useState([]);
  const { formatMessage } = useIntl();
  const [selectedRaffleDrawId, setSelectedRaffleDrawId] = useState(0);
  const [fileLink, setFileLink] = useState("");
  const [participantType, setParticipantType] = useState(0);
  //const [paginator, setPaginator] = useState((): ParticipantTabData => null)
  const [paginator, setPaginator] = useState(null);
  const [totalConfirmed, setTotalConfirmed] = useState(0);
  const [totalParticipants, setTotalParticipants] = useState(0);

  const [participantsFiltered, setParticipantsFiltered] = useState([]);

  const formik = useFormik({
    initialValues: {
      type_participant: 0,
    },
    validationSchema: Yup.object().shape({
      message: Yup.string().required(
        formatMessage({ id: "sharedScreen.selectDayOpeningHour" })
      ),
    }),
    onSubmit: async (values, { setSubmitting }: FormikHelpers<any>) => {
      setError(false);
      try {
        ICIPAdminService.getRaffleDraws().then((response) => {
          if (response.isSuccess) {
            switch (response.data.code) {
              case 100:
                const raffleResults = JSON.parse(
                  JSON.stringify(response.data.data)
                );
                setRaffleDraws(raffleResults);
                break;
              case 110:
                setError(true);
                console.log(error);
                break;
            }
          } else {
            setError(true);
          }
          //setLoading(false);
        });
      } catch (error) {
        setError(true);
      }
      setSubmitting(false);
    },
  });

  const fetchRafflesList = () => {
    ICIPAdminService.getRaffleDraws().then((response) => {
      if (response.isSuccess) {
        switch (response.data.code) {
          case 100:
            const raffleResults = JSON.parse(
              JSON.stringify(response.data.data)
            );
            setRaffleDraws(raffleResults);
            break;
          case 110:
            setError(true);
            console.log(error);
            break;
        }
      } else {
        setError(true);
      }
      //setLoading(false);
    });
  };

  useEffect(() => {
    fetchRafflesList();
  }, []);

  const handleChangeRaffleDrawAndSelect = (
    raffleDrawId: number,
    typeParticipantVal: number
  ) => {
    if (raffleDrawId === undefined) {
      setParticipants([]);
      setParticipantsFiltered([]);
      setSelectedRaffleDrawId(0);
      setPaginator(null);
    } else {
      ICIPAdminService.raffleDrawParticipantList(
        raffleDrawId,
        typeParticipantVal
      ).then((response) => {
        if (response.isSuccess) {
          switch (response.data.code) {
            case 100:
              let reqPaginator = Paginator.fromJson(
                JSON.parse(JSON.stringify(response.data.data["paginator"])),
                DataTypeEnum.raffleParticipants
              );
              setRaffleDrawsParticipants(reqPaginator.items);

              let confirmedParticipants = JSON.parse(
                JSON.stringify(response.data.data["confirmed_participants"])
              );
              let totalParticipantsResult = JSON.parse(
                JSON.stringify(response.data.data["total_participants"])
              );

              setPaginator(reqPaginator);
              setParticipants(reqPaginator.items);
              setParticipantsFiltered(reqPaginator.items);
              setSelectedRaffleDrawId(raffleDrawId);
              setTotalConfirmed(confirmedParticipants);
              setTotalParticipants(totalParticipantsResult);
              setParticipantType(typeParticipantVal);
              break;
            case 110:
              setError(true);
              console.log(error);
              break;
          }
        } else {
          setError(true);
        }
        //setLoading(false);
      });
    }
  };

  const exportParticipants = () => {
    ICIPAdminService.exportRaffleDrawParticipant(
      selectedRaffleDrawId,
      participantType
    ).then((response) => {
      if (response.isSuccess) {
        switch (response.data.code) {
          case 100:
            const raffleExportResult = JSON.parse(
              JSON.stringify(response.data.data)
            );
            document.location.href = response.data.data;
            setFileLink(raffleExportResult);
            break;
          case 110:
            setError(true);
            break;
        }
      } else {
        setError(true);
      }
      //setLoading(false);
    });
  };

  const searchItems = async (searchValue) => {
    if (searchValue !== "") {
      const filteredData = await participants.filter((item) => {
        return (
          Object.values(item.last_name)
            .join("")
            .toLowerCase()
            .includes(searchValue.toLowerCase()) ||
          Object.values(item.first_name)
            .join("")
            .toLowerCase()
            .includes(searchValue.toLowerCase()) ||
          Object.values(item.telephone)
            .join("")
            .toLowerCase()
            .includes(searchValue.toLowerCase())
        );
      });
      setParticipantsFiltered(filteredData);
    } else {
      setParticipantsFiltered(participants);
    }
  };

  const render = () => {
    return (
      <>
        <Grid item xs={4} sm={4} lg={4}>
          <InputSelect
            fullWidth
            id="raffle_draw_date"
            name="raffle_draw_date"
            value={formik.values.raffle_draw_date}
            label={intl.formatMessage({
              id: "sharedScreen.dateRaffleDraw",
            })}
            placeholdre={intl.formatMessage({
              id: "sharedScreen.dateRaffleDraw",
            })}
            onChange={(event) =>
              handleChangeRaffleDrawAndSelect(
                event.target.value,
                participantType
              )
            }
            error={
              Boolean(formik.touched.raffle_draw_date) &&
              Boolean(formik.errors.raffle_draw_date)
            }
            helperText={
              formik.touched.raffle_draw_date && formik.errors.raffle_draw_date
            }
          >
            <MenuItem>
              <FormattedMessage id="sharedScreen.dateRaffleDraw" />
            </MenuItem>
            {raffleDraws.map((raffleDraw, index) => {
              return (
                <MenuItem value={raffleDraw.id}>
                  {raffleDraw.raffle_draw_date}
                </MenuItem>
              );
            })}
          </InputSelect>
        </Grid>
        <Grid item xs={4} sm={4} lg={4}>
          <InputSelect
            fullWidth
            id="type_participant"
            name="type_participant"
            value={participantType}
            label={intl.formatMessage({
              id: "sharedScreen.typeParticipant",
            })}
            placeholdre={intl.formatMessage({
              id: "sharedScreen.typeParticipant",
            })}
            onChange={(event) =>
              handleChangeRaffleDrawAndSelect(
                selectedRaffleDrawId,
                event.target.value
              )
            }
            error={
              Boolean(formik.touched.type_participant) &&
              Boolean(formik.errors.type_participant)
            }
            helperText={
              formik.touched.type_participant && formik.errors.type_participant
            }
          >
            <MenuItem value={0}>
              <FormattedMessage id="sharedScreen.allParticipants" />
            </MenuItem>
            <MenuItem value={1}>
              <FormattedMessage id="sharedScreen.confirmedParticipants" />
            </MenuItem>
            <MenuItem value={2}>
              <FormattedMessage id="sharedScreen.notConfirmedParticipants" />
            </MenuItem>
          </InputSelect>
        </Grid>
        <Grid item xs={4} sm={4} lg={3}>
          <TextField
            fullWidth
            label={intl.formatMessage({
              id: "sharedScreen.searchParticipant",
            })}
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            onChange={(e) => searchItems(e.target.value)}
          />
        </Grid>
        <Box component="div">
          {paginator !== null && (
            <>
              <Typography variant="h4" component="h4">
                <FormattedMessage id="sharedScreen.totalParticipant" />:{" "}
                {totalParticipants}
              </Typography>

              {participantType === 2 ? (
                <Typography variant="h4" component="h4">
                  <FormattedMessage id="sharedScreen.totalNonConfirmed" />:{" "}
                  {totalParticipants - totalConfirmed}
                </Typography>
              ) : (
                <Typography variant="h4" component="h4">
                  <FormattedMessage id="sharedScreen.totalConfirmed" />:{" "}
                  {totalConfirmed}
                </Typography>
              )}
            </>
          )}
          {paginator !== null ? (
            <TableData
              paginator={
                paginator.total !== 0
                  ? {
                      total: paginator.total,
                      page: paginator.page,
                      totalPage: paginator.total_page,
                      title: "",
                      handlePrevAction:
                        paginator.prev_page !== null ? () => {} : null,
                      handleNextAction:
                        paginator.next_page !== null ? () => {} : null,
                    }
                  : null
              }
              rows={renderRafflesParticipantTableRows()}
              header={renderRafflesParticipantTableHeader()}
            />
          ) : (
            <></>
          )}
        </Box>
      </>
    );
  };

  const renderRafflesParticipantTableRows = () => {
    return participantsFiltered.map((row, index) => {
      let raffleDrawParticipant = row as RaffleDrawParticipant;

      return (
        <>
          <StyledTableRow key={index}>
            <StyledTableCell component="td" scope="row">
              {raffleDrawParticipant.last_name} {raffleDrawParticipant.first_name}
            </StyledTableCell>
            {/*<StyledTableCell component="td" scope="row">
              {raffleDrawParticipant.first_name}
            </StyledTableCell>*/}
            <StyledTableCell component="td" scope="row">
              {raffleDrawParticipant.telephone}
            </StyledTableCell>
            <StyledTableCell component="td" scope="row">
              {raffleDrawParticipant.country_iso_code}
            </StyledTableCell>
            <StyledTableCell component="td" scope="row">
              {raffleDrawParticipant.confirmed_at === null ? (
                <Alert severity="info">
                  <Typography variant="h6" component="h6">
                    <FormattedMessage id="sharedScreen.noDateSpecified" />
                  </Typography>
                </Alert>
              ) : (
                moment
                  .utc(raffleDrawParticipant.confirmed_at)
                  .local()
                  .format("DD/MM/YYYY")
              )}
            </StyledTableCell>
          </StyledTableRow>
        </>
      );
    });
  };

  const renderRafflesParticipantTableHeader = () => {
    return (
      <>
        <TableRow>
          <StyledTableCell align="center" className={classes.tabHeading}>
            <FormattedMessage id="sharedScreen.RaffleDrawParticipantName" />
          </StyledTableCell>
          {/*<StyledTableCell align="left" className={classes.tabHeading}>
            <FormattedMessage id="sharedScreen.RaffleDrawParticipantFirstName" />
          </StyledTableCell>*/}
          <StyledTableCell align="center" className={classes.tabHeading}>
            <FormattedMessage id="sharedScreen.raffleDrawParticipantTelephone" />
          </StyledTableCell>
          <StyledTableCell align="center" className={classes.tabHeading}>
            <FormattedMessage id="sharedScreen.RaffleDrawParticipantCountryCode" />
          </StyledTableCell>
          <StyledTableCell align="center" className={classes.tabHeading}>
            <FormattedMessage id="sharedScreen.RaffleDrawParticipantConfirmationDate" />
          </StyledTableCell>
        </TableRow>
      </>
    );
  };

  return (
    <>
      <Grid item xs={12} sm={6} lg={1}>
        <Button
          className={classes.exportButton}
          color="secondary"
          variant="contained"
          fullWidth
          disabled={selectedRaffleDrawId !== 0 ? false : true}
          onClick={(event) => exportParticipants()}
        >
          Export To Excel
        </Button>
      </Grid>
      <Box className={classes.contentListParticipant} component="div">
        {render()}
      </Box>
    </>
  );
};
